import { Icon } from "./Icon.tsx";

/** Toggle the element browser sidebar (App.tsx) — a bulleted list, matching what that panel actually is (a grouped list of elements), clearer than a generic panel/layout glyph. */
export function ListIcon() {
  return (
    <Icon>
      <circle cx="4" cy="6" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="4" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="4" cy="18" r="1.5" fill="currentColor" stroke="none" />
      <line x1="9" y1="6" x2="21" y2="6" />
      <line x1="9" y1="12" x2="21" y2="12" />
      <line x1="9" y1="18" x2="21" y2="18" />
    </Icon>
  );
}
